<template>
  <div class="categoryListing">
    <section class="main_content">
      <div class="cat_wrap">
        <ul class="category_tab">
          <li
            v-for="(category,index) in categories"
            :key="index"
            :class="{'active':index == catIndex}"
          >
            <span @click="getAllCategories(category.id,category.name,index)">{{category.name}}</span>
          </li>
        </ul>
        <div class="rght_tab" :id="parentCategoryId">
          <h4>{{parentName}}</h4>
          <div class="cata_row">
            <div
              class="prod_col"
              v-for="(subcategory,index) in subCategoriesDto"
              :key="index"
              @click="goToGetProductByCategory(subcategory.id,subcategory.name)"
            >
              <div class="prod_inner" v-if="subcategory.bgImageURL">
                <img :src="subcategory.bgImageURL" alt="subcategory-image" />
              </div>
              <span>{{subcategory.name}}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="cntntLoad" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import VueCookie from "vue-cookie";
import { bus } from "../../main";
import "../../assets/css/category-tab.scss";
export default {
  name: "CategoryListing",
  components: {},
  data() {
    return {
      orderDetails: {},
      addressDTO: {},
      subOrderDto: [],
      orderStatus: {},
      loading: false,
      categories: [],
      parentCategoryId: "",
      parentName: "",
      subCategoriesDto: [],
      catIndex: 0
    };
  },
  methods: {
    getAllCategories(categoryId, name, index) {
      this.loading = true;
      this.subCategoriesDto = [];
      this.$store
        .dispatch({
          type: "getAllCategories",
          payload: categoryId
        })
        .then(data => {
          this.parentCategoryId = "subcategory" + categoryId;
          this.parentName = name;
          if (categoryId == 0) {
            this.categories = data.data.childCategories;
            this.$store.commit("saveCategories", {
              categories: this.categories,
              catId: categoryId,
              catIndex: index
            });
            //first subcategory
            if (this.categories.length > 0) {
              this.getAllCategories(
                this.categories[0].id,
                this.categories[0].name,
                0
              );
            }
            this.catIndex = index;
            this.loading = false;
          } else {
            this.$store.commit("saveCatId", {
              catId: categoryId,
              catName: name,
              catIndex: index
            });
            if (data.data.childCategories === null) {
              this.subCategoriesDto.push(data.data);
            } else {
              this.subCategoriesDto = data.data.childCategories;
            }
            this.$store.commit("saveSubCategories", {
              subCategoriesDto: this.subCategoriesDto,
              subCatId: categoryId
            });
          }
          this.catIndex = index;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    goToGetProductByCategory(categoryId, name) {
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push(
        "/product-by-category?type=NORMAL&categoryid=" + categoryId
      );
    }
  },
  mounted() {
    if (this.$store.getters.categories.length > 0) {
      this.categories = this.$store.getters.categories;
      this.catIndex = this.$store.getters.catIndex;
      this.parentName = this.$store.getters.catName;
      if (
        this.$store.getters.subCategoriesDto.length > 0 &&
        Number(this.$store.getters.catId) ==
          Number(this.$store.getters.subCatId)
      ) {
        this.subCategoriesDto = this.$store.getters.subCategoriesDto;
      } else {
        this.catIndex = 0;
        this.getAllCategories(
          this.categories[0].id,
          this.categories[0].name,
          0
        );
      }
    } else {
      this.catIndex = 0;
      this.getAllCategories(0, "", 0);
    }
  }
};
</script>
